<template>
  <router-link :to="redirectTo" class="product-preview hover-shadow">
    <div
      class="md:p-2 h-full"
      @mouseover="hovering = true"
      @mouseleave="hovering = false"
    >
      <div class="img-box">
        <img :src="productImage" class="product-img">
        <div v-if="product.stockInUsa" class="absolute left-0 flex items-center">
          <img src="@/assets/icons/usa.svg" class="flag">
          <div class="pl-2 pt-1 text-xs">Stock in USA</div>
        </div>
      </div>
      <div class="detail-box">
        <p class="detail-box-name whitespace-nowrap">{{ product.name }}</p>
        <p
          v-if="product.displayMoq"
          class="detail-box-moq whitespace-nowrap"
        >
          MOQ: {{ product.displayMoq }}
        </p>
        <div class="detail-box-price whitespace-nowrap">{{ product.price }}</div>
        <div class="hidden md:block pt-4 h-12">
          <button
            v-if="hovering"
            class="w-full bg-blue rounded-lg text-white py-1"
            @click.prevent="addToCart(product.id)"
          >
            Add to cart
          </button>
        </div>
      </div>
    </div>
  </router-link>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'ProductPreview',
  props: {
    product: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      hovering: false,
      hoveredOption: -1,
      showToolTip: false
    }
  },
  computed: {
    ...mapGetters ([
      'isUserLoggedIn'
    ]),
    productImage() {
      return this.product.image ? this.product.image : this.product.images[0]
    },
    rating() {
      return this.product.supplierRating ? this.product.supplierRating : this.product.supplier.rating
    },
    redirectTo() {
      if (this.forSupplierPreview) return ''
      return this.product.slug ? `/${this.product.slug}` : `/products/${this.product.id}`
    },
    forSupplierPreview() {
      return this.$route.name === 'SupplierPreview' || this.$route.name === 'ProductPreviewForSupplier'
    }
  },
  methods: {
    ...mapActions ([
      'getProductInfo',
      'addItemToCart'
    ]),
    async addToCart() {
      if (this.forSupplierPreview) return
      const product = await this.getProductInfo(this.product.id)
      product.inco_terms = product.incoTerms[0]
      product.quantity = product.minimumOrderQuantity
      const status = await this.addItemToCart(product)
      const msg = status === 'Added' ? 'Product added to cart' : 'Product quantity updated in cart'
      this.$notify({
        group: 'buyHive',
        type: 'success',
        text: msg
      })
    }
  }
}
</script>
<style lang="scss" scoped>
  .product-preview {
    @apply block border border-transparent rounded;
    .img-box {
      @apply relative h-40 pt-2 pb-6;
      @screen md { @apply h-56; }
      .product-img { @apply mx-auto h-auto w-auto max-h-full }
      .flag { @apply w-8; }
    }
    .detail-box {
      @apply pt-2;
      &-name {
        @apply capitalize pb-1 overflow-hidden w-full;
        text-overflow: ellipsis;
      }
      &-moq {
        @apply text-sm opacity-50 overflow-hidden w-full;
        text-overflow: ellipsis;
      }
      &-price {
        @apply pt-1 tracking-tighter text-lg font-semibold overflow-hidden w-full;
        text-overflow: ellipsis;
      }
    }
  }
</style>
